<script>
  import { format } from 'svelte-i18n';
  import { Input, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { sanitizeRulenameOnKeyUp } from '@client/utils/sanitize';

  import { DEFAULT_PLUGIN_CONFIGS } from '@client/enums';

  import { deepCopyArray } from '@common/utils/arrays';

  import { PluginParameters } from '../../edit/plugin-parameters';

  export let provider = '';
  export let rulename = '';
  export let parameters = [];
  export let fallbacktext = '';
  export let currentRulenames = [];

  let defaultConfig = deepCopyArray(DEFAULT_PLUGIN_CONFIGS);

  $: matchingConfig = defaultConfig[provider] || [];
</script>

<div class="integration-details-form">
  <div>
    <div class="logo">
      <img
        src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
        style="background: url('https://assets.opensense.com/plugins/{!provider
          ? 'opensense'
          : provider}.svg') no-repeat center center; background-size: contain;"
        alt={provider}
        draggable="false"
      />
    </div>
    <p>{$format('label.INTEGRATION_FORM_MODAL_FILL_IN_FORM')}</p>
  </div>

  <div class="modal-body">
    <div class="section">
      <div class="heading">
        {$format('label.NAME')} <Icon name="help-circle" id="rulename-info" class="cursor-help h5" />
      </div>
      <Tooltip target="rulename-info" placement="top">{$format('label.TOOLTIP.INTEGRATION_RULENAME')}</Tooltip>
      <Input
        type="text"
        placeholder={$format('label.PLACEHOLDER.INPUT', {
          values: { param: $format('label.NAME').toLowerCase() }
        })}
        invalid={currentRulenames.includes(rulename) || (0 < rulename.length && rulename.length < 3)}
        feedback={currentRulenames.includes(rulename)
          ? $format('label.VALIDATION_NAME_EXISTS', {
              values: {
                type: $format('label.INTEGRATION'),
                param: $format('label.NAME').toLowerCase()
              }
            })
          : $format('label.VALIDATION_TOO_SHORT', {
              values: { param: $format('label.RULENAME'), length: 3 }
            })}
        on:keyup={() => {
          rulename = sanitizeRulenameOnKeyUp(rulename);
        }}
        bind:value={rulename}
      />
    </div>
    <div class="section">
      <div class="heading">{$format('label.PARAMETERS')}</div>
      <PluginParameters bind:params={parameters} defaultConfig={matchingConfig} />
    </div>
    <div class="section">
      <div class="heading">
        {$format('label.FALLBACK_TEXT')} <Icon name="help-circle" id="fallback-text-info" class="cursor-help h5" />
      </div>
      <Tooltip target="fallback-text-info" placement="top">{$format('label.TOOLTIP.INTEGRATION_FALLBACK_TEXT')}</Tooltip
      >
      <Input
        type="text"
        placeholder={$format('label.PLACEHOLDER.INPUT', {
          values: { param: $format('label.FALLBACK_TEXT').toLowerCase() }
        })}
        bind:value={fallbacktext}
      />
    </div>
  </div>
</div>

<style lang="scss">
  .integration-details-form {
    width: 100%;

    > div:first-child {
      text-align: center;
    }

    .logo {
      height: 60px;
      margin: var(--margin-large) auto;
      width: 130px;

      img {
        background-size: contain !important;
        display: block;
        height: 60px;
        pointer-events: none;
        touch-action: none;
        user-select: none;
        width: 130px;
      }
    }

    .modal-body {
      text-align: left;
      width: 100%;
    }

    .section {
      &:first-child {
        margin-top: var(--margin-base);
      }

      + .section {
        margin-top: var(--margin-xlarge);
      }

      .heading {
        font-size: var(--font-size-large);
        font-weight: var(--font-weight-medium);
        margin-bottom: var(--margin-base);
      }
    }

    :global(.invalid-feedback) {
      color: var(--color-red-500);
      font-size: var(--font-size-medium);
      margin-top: var(--margin-base);
    }
  }
</style>
